
define('ldsh!modules/user/create/template', [], function() {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<h1>User</h1>\n<div class="form form-horizontal" role="form">\n  \n\n  <div class="form-group">\n    <label for="Username">Username</label>\n    <input type="text" class="form-control" id="username" name="username" placeholder="Username">\n  </div>\n\n  \n\n  <div class="form-group">\n    <label for="Password">Password</label>\n    <input type="text" class="form-control" id="password" name="password" placeholder="Password">\n  </div>\n\n\n\n\n\n\n\n\n\n\n\n\n  <button type="button" class="btn btn-default submitForm">Submit</button>\n</div>';

}
return __p
};});

